import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createTextVNode as _createTextVNode, createBlock as _createBlock, withModifiers as _withModifiers, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-53ccf443"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main_project" }
const _hoisted_2 = { class: "list_search" }
const _hoisted_3 = { class: "search_header" }
const _hoisted_4 = {
  class: "flexWrap",
  style: {"width":"80%"}
}
const _hoisted_5 = { class: "header_nr flexAlign" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nr_left" }, "项目名称：", -1))
const _hoisted_7 = { class: "header_nr flexAlign" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nr_left" }, "项目编号：", -1))
const _hoisted_9 = { class: "header_nr flexAlign" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nr_left" }, "项目类型：", -1))
const _hoisted_11 = {
  key: 0,
  style: {"margin-left":"8px","color":"#909399","font-size":"13px"}
}
const _hoisted_12 = { class: "header_nr flexAlign" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nr_left" }, "项目状态：", -1))
const _hoisted_14 = {
  class: "header_twonr",
  style: {"margin-top":"20px"}
}
const _hoisted_15 = /*#__PURE__*/_createTextVNode("查询")
const _hoisted_16 = /*#__PURE__*/_createTextVNode("添加")
const _hoisted_17 = { class: "normal" }
const _hoisted_18 = /*#__PURE__*/_createTextVNode("查看计划")
const _hoisted_19 = /*#__PURE__*/_createTextVNode("评审")
const _hoisted_20 = /*#__PURE__*/_createTextVNode("完善项目信息")
const _hoisted_21 = /*#__PURE__*/_createTextVNode("所有附件")
const _hoisted_22 = /*#__PURE__*/_createTextVNode("编辑")
const _hoisted_23 = /*#__PURE__*/_createTextVNode("恢复")
const _hoisted_24 = /*#__PURE__*/_createTextVNode("移除")
const _hoisted_25 = /*#__PURE__*/_createTextVNode("项目进度")
const _hoisted_26 = /*#__PURE__*/_createTextVNode("逾期未处理任务")
const _hoisted_27 = /*#__PURE__*/_createTextVNode("逾期任务")
const _hoisted_28 = {
  class: "flexEnd",
  style: {"padding":"20px"}
}
const _hoisted_29 = { class: "my-header" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "评审 - 订单信息任务配置", -1))
const _hoisted_31 = { style: {"margin-bottom":"10px","color":"#606266","font-size":"13px"} }
const _hoisted_32 = { style: {"margin-bottom":"10px","display":"flex","align-items":"center","gap":"8px"} }
const _hoisted_33 = /*#__PURE__*/_createTextVNode("全选")
const _hoisted_34 = /*#__PURE__*/_createTextVNode("全不选")
const _hoisted_35 = /*#__PURE__*/_createTextVNode("反选")
const _hoisted_36 = { style: {"color":"#909399","font-size":"12px"} }
const _hoisted_37 = { style: {"display":"flex","align-items":"center","justify-content":"center","gap":"2px"} }
const _hoisted_38 = /*#__PURE__*/_createTextVNode("上传附件")
const _hoisted_39 = ["href"]
const _hoisted_40 = {
  key: 0,
  style: {"text-align":"center","padding":"30px","color":"#909399"}
}
const _hoisted_41 = {
  class: "flexCenter",
  style: {"margin-top":"15px"}
}
const _hoisted_42 = /*#__PURE__*/_createTextVNode("取 消")
const _hoisted_43 = /*#__PURE__*/_createTextVNode("提 交")
const _hoisted_44 = { class: "my-header" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "添加编辑项目", -1))
const _hoisted_46 = { class: "my-header" }
const _hoisted_47 = /*#__PURE__*/_createTextVNode("取 消")
const _hoisted_48 = /*#__PURE__*/_createTextVNode("保 存")
const _hoisted_49 = { class: "qp" }
const _hoisted_50 = { class: "my-header" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "项目日志", -1))

import { useRouter,useRoute } from 'vue-router';
	import { ElMessage } from 'element-plus';
	import { CirclePlus,Search } from '@element-plus/icons-vue';
	import { ref,onMounted,computed,nextTick,watch } from 'vue';
	import AddProject from '@/components/AddProject.vue';
	import AddProjectlog from '@/components/AddProjectlog.vue';
	import ProjectInfoEdit from '@/components/ProjectInfoEdit.vue';
import ProjectAllFiles from '@/components/ProjectAllFiles.vue';
	import { requestProjectList,requestTaskGanttList,xmUser } from '@/api/xmApi';
	import { requestBaseDel,requestMyuser,requestReset,requestgetselfrole,requestprojectstatuspscreate,apiName } from '@/api/api';
	import { requestGetAllConfig } from '@/api/configApi'
import { reqFormInstanceTemplateList, reqFormInstanceCreate } from '@/api/forminstanceApi'

	
export default /*#__PURE__*/_defineComponent({
  name: 'Project',
  setup(__props) {

	const router = useRouter()
	const route = useRoute()
	const tableData = ref<any[]>([])
	const sfLists = ref<any[]>([])
	const loading = ref<boolean>(false)
	const projectShow = ref<boolean>(false)//打开编辑
	const logDetails = ref<boolean>(false)//打开日志
	const logDetailsShow = ref<boolean>(false)
	const uuid = ref<string>("")//打开编辑传uuid
	const pageIndex = ref<number>(1)
	const pageSize = ref<number>(10)
	const pages = ref({
		totalCount:0
	})
	const api = ref<string>(apiName)
	const formTemplateList = ref<any[]>([])

	const getsfLists = () =>{
		requestGetAllConfig({
			type:"省份"
		}).then((res:any)=>{
			if(res.status === 1){
				sfLists.value = res.datalist
			}
		})
	}
	const projectnr = ref({})//项目
	const search = ref({
		code:'',
		projectname:'',
		type1:0,
		status: 1
	})//搜索
	// 菜单范围 -> 项目类别集合：项目管理(/project)=售前/售中/售后；内部项目管理(/projectinternal)=公司内部项目
	const getScopeTypes = (path: string): string => {
		if (path === "/projectinternal") return "4"
		if (path === "/project") return "1,2,3"
		return ""
	}
	const getScopeName = (path: string): string => {
		if (path === "/projectinternal") return "内部项目管理"
		if (path === "/project") return "项目管理"
		return ""
	}
	// 来自菜单的类别过滤（非空时按此集合过滤，并禁用类别下拉）
	const typeListFilter = ref<string>("")
	const menuScopeName = ref<string>("")
	const addShowProject = ref<boolean>(false)//添加编辑项目
	const addShowTask = ref<boolean>(false)//添加任务
	const taskid = ref<number>(0)//新建详情任务id
	const userList = ref<any>({})
	const userrole = ref<string>("")//用户角色

	onMounted(()=>{
		console.log(1);
		console.log(route.query);
		if(route.query.page){
			pageIndex.value = parseInt(route.query.page as string) || 1
		}
		if(route.query.size){
			pageSize.value = parseInt(route.query.size as string) || 10
		}
		// 恢复查询条件：从任务列表返回时保持上次的筛选内容
		if(route.query.projectname !== undefined){
			search.value.projectname = route.query.projectname as string
		}
		if(route.query.code !== undefined){
			search.value.code = route.query.code as string
		}
		if(route.query.type1 !== undefined){
			search.value.type1 = parseInt(route.query.type1 as string) || 0
		}
		if(route.query.status !== undefined){
			search.value.status = parseInt(route.query.status as string) || 0
		}
		// 根据当前路由区分菜单范围（/project=项目管理；/projectinternal=内部项目管理）
		typeListFilter.value = getScopeTypes(route.path)
		menuScopeName.value = getScopeName(route.path)
		requestgetselfrole().then((res:any)=>{
			if(res.status === 1){
				userrole.value = res.datalist
				console.log(userrole.value)
			}
		})

		getMyUser()
		getList()
		getsfLists()
		
	})
	// 切换菜单/tab 时，根据路由重新应用类别范围过滤
	watch(() => route.path, (nv: string) => {
		if (nv !== "/project" && nv !== "/projectinternal") return
		typeListFilter.value = getScopeTypes(nv)
		menuScopeName.value = getScopeName(nv)
		pageIndex.value = 1
		getList()
	})
	const getSf = (val: number) =>{
		for(var i=0;i<sfLists.value.length;i++){
			if(val==sfLists.value[i].id){
				return sfLists.value[i].value
			}
		}
		return ""
	} 
	const getType = computed(()=>{
		return function(status:number){
			let b = {
				1:'primary',
				2:'danger',
				3:'success',
				4:'warning'
			}
			return b[status]
		}
	})
	const getStatus = computed(()=>{
		return function(status:number){
			let a = {
				1:"进行中",
				2:"关闭",
				3:"完成",
				4:"恢复"
			}
			return a[status]
		}
	})
	// 是否可管理（移除/恢复/编辑）：创建人本人 或 角色为管理员
	const canManage = (row: any): boolean => {
		if (row && row.cell && row.cell.createid == userList.value.id) return true
		const rolelist = userList.value.rolelist || ''
		if (typeof rolelist === 'string' && rolelist.indexOf('管理员') > -1) return true
		if (Array.isArray(rolelist) && rolelist.indexOf('管理员') > -1) return true
		return false
	}
	const type1tostring = (val: number) =>{
		if(val==1){
			return  "项目售前"
		}
		if(val==2){
			return  "项目售中"
		}
		if(val==3){
			return  "项目售后"
		}
		if(val==4){
			return  "公司内部项目"
		}
		if(val==5){
			return  "周计划投产"
		}
	}
	//任务详情：跳转前先把当前页码/每页条数写入本页路由，返回时据此恢复
	const goTaskList = (row: any, yuqi: number) => {
		taskid.value = parseInt(row.cell.id)
		router.replace({query:{...route.query, page:String(pageIndex.value), size:String(pageSize.value),
			projectname:search.value.projectname || '',
			code:search.value.code || '',
			type1:String(search.value.type1 || 0),
			status:String(search.value.status || 0)
		}}).then(() => {
			router.push({name:'TaskList',params:{taskid:parseInt(row.cell.id),yuqi:yuqi}})
		})
	}
	const taskDetails = (row: any) => {
		goTaskList(row, 0)
	}
	const taskDetails1 = (row: any) => {
		goTaskList(row, 1)
	}
	const taskDetails2 = (row: any) => {
		goTaskList(row, 2)
	}
	const getList = () =>{
		loading.value = true
		const params:any = {
			pageIndex:pageIndex.value,
			pageSize:pageSize.value,
			projectname:search.value.projectname,
			code:search.value.code,
			type1:search.value.type1,
			status:search.value.status
		}
		// 来自菜单范围过滤时，按类别集合过滤（type1 置 0，移交 type1list 处理）
		if (typeListFilter.value) {
			params.type1 = 0
			params.type1list = typeListFilter.value
		}
		requestProjectList(params).then((res:any)=>{
			tableData.value = res.data
			pages.value.totalCount = res.totalCount
			loading.value = false
		})
	}
	const getMyUser = () => {
		requestMyuser().then((res:any)=>{
			if(res.status === 1){
				userList.value = res.datalist[0]
			}
		})
	}
	//打击查看日志
	const lookLog = (row: any) => {
		projectnr.value = row.cell
		logDetailsShow.value = false
		nextTick(()=>{
			logDetailsShow.value = true
		})
		logDetails.value = true
	}
	// ===== 评审：改为先弹出配置表格，按配置创建订单信息任务 =====
	const psShow = ref<boolean>(false)
	const psLoading = ref<boolean>(false)
	const psSubmitting = ref<boolean>(false)
	const psList = ref<any[]>([])
	const psTaskTree = ref<any[]>([])
	const psUserList = ref<any[]>([])
	const psProject = ref<any>({})
	const formatDate = (d: Date): string => {
		const y = d.getFullYear()
		const m = String(d.getMonth() + 1).padStart(2, '0')
		const dd = String(d.getDate()).padStart(2, '0')
		return `${y}-${m}-${dd}`
	}
	// 打开评审配置弹窗
	const ps = (row: any) => {
		psProject.value = { id: row.cell.id, projectname: row.cell.projectname, code: row.cell.code }
		psList.value = []
		psShow.value = true
		loadPsFormTemplates()
		psLoading.value = true
		Promise.all([
			requestGetAllConfig({ type: '事项类型' }),
			requestTaskGanttList({ projectid: row.cell.id }),
			xmUser()
		]).then(([cfgRes, taskRes, userRes]: any) => {
			// 人员列表
			psUserList.value = (userRes && userRes.status === 1) ? (userRes.datalist || []) : []
			// 项目已有任务：用于上级任务树 + 判断同事项类型是否已创建
			const taskRows = Array.isArray(taskRes) ? taskRes : ((taskRes && taskRes.datalist) || [])
			const tasks = taskRows.map((t: any) => (t.cell ? t.cell : t))
			psTaskTree.value = buildPsTaskTree(tasks)
			const existTypes: {[k: string]: boolean} = {}
			tasks.forEach((t: any) => { if (t.type1) existTypes[t.type1] = true })
			// 事项类型配置：只取"订单信息-"开头的
			const cfg = (cfgRes && cfgRes.status === 1) ? (cfgRes.datalist || []) : []
			const today = new Date()
			const tomorrow = new Date(today)
			tomorrow.setDate(today.getDate() + 1)
			psList.value = cfg
				.filter((c: any) => String(c.value || '').indexOf('订单信息-') === 0)
				.map((c: any, index: number) => ({
					index,                                  // 事项类型在配置中的原始顺序（后端 step 序号用）
					type1: c.value,                         // 事项类型名称
					tasktitle: c.value,
					taskdescribe: c.key || '',              // 任务描述默认取配置 key
					zxr: (c.field0 && c.field1) ? `${c.field0},${c.field1}` : '',   // 执行人默认取配置
					shr: (c.field2 && c.field3) ? `${c.field2},${c.field3}` : '',   // 审核人默认取配置
					startdate: formatDate(today),
					enddate: formatDate(tomorrow),
					status: 1,                              // 任务状态默认"进行中"
					taskpid: '',
					existType: !!existTypes[c.value],
					// 同类型任务已创建时默认不勾选，避免重复创建
					create: !!existTypes[c.value] ? 0 : 1,
					fileList: [],
					formid: '',
					isurgent: '否'
					}))
		}).catch(() => {
			ElMessage.error('加载评审配置失败')
		}).finally(() => {
			psLoading.value = false
		})
	}
	// 把扁平任务列表构建成树（按 taskpid）
	const buildPsTaskTree = (tasks: any[]): any[] => {
		const map: any = {}
		const tree: any[] = []
		tasks.forEach((t: any) => {
			map[String(t.id)] = { ...t, children: [] }
		})
		tasks.forEach((t: any) => {
			const node = map[String(t.id)]
			const pid = String(t.taskpid || '0')
			if (pid && pid !== '0' && map[pid] && pid !== String(t.id)) {
				map[pid].children.push(node)
			} else {
				tree.push(node)
			}
		})
		return tree
	}
	// ===== 订单信息任务配置：创建列 全选 / 全不选 / 反选 =====
	// 已勾选数量
	const psCheckedCount = computed(() => psList.value.filter((r: any) => Number(r.create) === 1).length)
	// 表头全选框状态：全部勾选为 true，部分勾选为 indeterminate
	const psAllChecked = computed(() => psList.value.length > 0 && psCheckedCount.value === psList.value.length)
	const psIndeterminate = computed(() => !psAllChecked.value && psCheckedCount.value > 0)
	// 全选 / 全不选
	const psSelectAll = (val: any) => {
		const v = (val === true || val === 1) ? 1 : 0
		psList.value.forEach((r: any) => { r.create = v })
	}
	// 反选
	const psInvert = () => {
		psList.value.forEach((r: any) => { r.create = Number(r.create) === 1 ? 0 : 1 })
	}
	// 行内附件上传：el-upload 的 on-success/on-remove 第三个参数为最新文件列表，直接同步回该行
	const onRowUploadSuccess = (row: any, fl: any[]) => { row.fileList = fl }
	const onRowUploadRemove = (row: any, fl: any[]) => { row.fileList = fl }
	// 加载"签字流程"表单模板列表（评审弹窗内下拉用）
	const loadPsFormTemplates = () => {
		reqFormInstanceTemplateList({}).then((res: any) => {
			if (res.status === 1) {
				formTemplateList.value = res.datalist || []
			}
		})
	}
	// 提交：按表格配置创建
	const submitPS = () => {
		const items = psList.value
			.filter((r: any) => Number(r.create) === 1)
			.map((r: any) => {
				const zxr = r.zxr ? String(r.zxr).split(',') : ['', '']
				const shr = r.shr ? String(r.shr).split(',') : ['', '']
				return {
					index: r.index,
					type1: r.type1,
					tasktitle: r.type1,
					taskdescribe: r.taskdescribe || '',
					operatoruserid: zxr[0] || '',
					operatorname: zxr[1] || '',
					checkuserid: shr[0] || '',
					checkname: shr[1] || '',
					startdate: r.startdate || '',
					enddate: r.enddate || '',
					status: Number(r.status) || 0,
					taskpid: Number(r.taskpid) || 0,
					filelist: (r.fileList || []).map((f: any) => (f.response && f.response.data && f.response.data[0]) ? f.response.data[0].url : f.url).filter((u: any) => u).join(','),
					formid: Number(r.formid) || 0,
					isurgent: r.isurgent || '否',
					create: 1
					}
					})
		if (items.length === 0) {
			ElMessage.warning('请至少勾选一个需要创建的事项类型')
			return
		}
		psSubmitting.value = true
		requestprojectstatuspscreate({
			id: psProject.value.id,
			projectname: psProject.value.projectname,
			code: psProject.value.code,
			items: JSON.stringify(items)
		}).then((res: any) => {
			if (res.status === 1) {
				ElMessage({ message: res.msg, type: 'success', duration: 1500 })
				// 为勾选了签字流程的任务创建表单实例（异步，不影响主流程）
				const created = (res.datalist || []).filter((t: any) => Number(t.formid) > 0)
				if (created.length) {
					Promise.allSettled(created.map((t: any) =>
						reqFormInstanceCreate({ taskid: t.id, taskuuid: t.uuid, formid: t.formid })))
				}
				psShow.value = false
				setTimeout(() => { getList() }, 500)
			} else {
				ElMessage.error(res.msg || '创建失败')
			}
		}).catch(() => {
			ElMessage.error('创建失败')
		}).finally(() => {
			psSubmitting.value = false
		})
	}
	// ===== 项目所有附件（复用公共组件）=====
const allFilesRef = ref<any>(null)
const openAllFiles = (row: any) => {
	if (allFilesRef.value) {
		allFilesRef.value.open(
			(row && row.cell && row.cell.uuid) || '',
			(row && row.cell && row.cell.projectname) || ''
		)
	}
}

// ===== 完善项目信息 =====
	const projectInfoShow = ref<boolean>(false)
	const projectInfoUuid = ref<string>('')
	const projectInfoName = ref<string>('')
	const projectInfoCode = ref<string>('')//项目编号，用于自动填充批次号
	const projectInfoRef = ref<any>(null)
	const projectInfoSaving = ref<boolean>(false)
	const openProjectInfo = (row: any) => {
		projectInfoUuid.value = (row && row.cell && row.cell.uuid) || ''
		projectInfoName.value = (row && row.cell && row.cell.projectname) || ''
		projectInfoCode.value = (row && row.cell && row.cell.code) || ''
		projectInfoShow.value = true
		// 组件挂载后加载该项目已填写的信息
		nextTick(() => { if (projectInfoRef.value) projectInfoRef.value.load() })
	}
	const saveProjectInfo = () => {
		if (!projectInfoRef.value) return
		projectInfoSaving.value = true
		projectInfoRef.value.save()
		// 保存结果由组件提示，这里同步结束 loading 状态
		setTimeout(() => { projectInfoSaving.value = false }, 800)
	}
	const onProjectInfoSaved = () => {
		projectInfoShow.value = false
		projectInfoSaving.value = false
		getList()
	}
	//详情
	const detailsProject = (row: any) =>{
		uuid.value = row.cell.uuid
		sx();
		addShowProject.value = true
	}
	const sx = () =>{
		projectShow.value = false
		nextTick(()=>{
			projectShow.value = true
		})
	}
	//添加
	const add = () =>{
		uuid.value = ""
		sx();
		addShowProject.value = true
	}
	const handleSizeChange = (val: number) =>{
		pageSize.value = val
		getList()
	}
	const handleCurrentChange = (val: number) =>{
		pageIndex.value = val
		getList()
	}
	const cancel = (val:any) =>{
		addShowProject.value = false
		if(val){
			getList()
		}
	}
	const searchList = () =>{
		pageIndex.value = 1
		getList();
	}
	// 恢复
	const hfProject = (row:any) =>{
		requestReset({
			type:"project",
			uuid:row.cell.uuid
		}).then((res:any)=>{
			if(res.status === 1){
			    ElMessage({
			        message: "恢复成功",
			        type: 'success',
			        duration: 500
			    });
				setTimeout(()=>{
					pageIndex.value = 1
					getList()
				},500)
			}
		})
	}
	// 移除
	const delProject = (row:any) =>{
		requestBaseDel({
			type:"project",
			uuid:row.cell.uuid
		}).then((res:any)=>{
			if(res.status === 1){
			    ElMessage({
			        message: "移除成功",
			        type: 'success',
			        duration: 500
			    });
				setTimeout(()=>{
					//pageIndex.value = 1
					getList()
				},500)
			}
		})
	}

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_Close = _resolveComponent("Close")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_tree_select = _resolveComponent("el-tree-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createVNode(_component_el_input, {
              size: "small",
              modelValue: search.value.projectname,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((search.value.projectname) = $event)),
              style: {width:'100px'},
              onKeyup: _cache[1] || (_cache[1] = _withKeys(($event: any) => (searchList()), ["enter","native"]))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createVNode(_component_el_input, {
              size: "small",
              modelValue: search.value.code,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((search.value.code) = $event)),
              style: {width:'100px'},
              onKeyup: _cache[3] || (_cache[3] = _withKeys(($event: any) => (searchList()), ["enter","native"]))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createVNode(_component_el_select, {
              modelValue: search.value.type1,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((search.value.type1) = $event)),
              size: "small",
              placeholder: "请选择",
              style: {"width":"80px"},
              disabled: !!typeListFilter.value,
              title: typeListFilter.value ? ('当前范围：'+menuScopeName.value) : ''
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_option, {
                  label: "全部",
                  value: 0
                }),
                _createVNode(_component_el_option, {
                  label: "项目售前",
                  value: 1
                }),
                _createVNode(_component_el_option, {
                  label: "项目售中",
                  value: 2
                }),
                _createVNode(_component_el_option, {
                  label: "项目售后",
                  value: 3
                }),
                _createVNode(_component_el_option, {
                  label: "公司内部项目",
                  value: 4
                }),
                _createVNode(_component_el_option, {
                  label: "周计划投产",
                  value: 5
                })
              ]),
              _: 1
            }, 8, ["modelValue", "disabled", "title"]),
            (typeListFilter.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_11, "（" + _toDisplayString(menuScopeName.value) + "）", 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_12, [
            _hoisted_13,
            _createVNode(_component_el_select, {
              modelValue: search.value.status,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((search.value.status) = $event)),
              size: "small",
              placeholder: "请选择",
              style: {"width":"80px"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_option, {
                  label: "全部",
                  value: 0
                }),
                _createVNode(_component_el_option, {
                  label: "进行中",
                  value: 1
                }),
                _createVNode(_component_el_option, {
                  label: "关闭",
                  value: 2
                }),
                _createVNode(_component_el_option, {
                  label: "完成",
                  value: 3
                }),
                _createVNode(_component_el_option, {
                  label: "已删除",
                  value: 4
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createVNode(_component_el_button, {
            plain: "",
            type: "primary",
            size: "small",
            icon: _unref(Search),
            onClick: _cache[6] || (_cache[6] = ($event: any) => (searchList()))
          }, {
            default: _withCtx(() => [
              _hoisted_15
            ]),
            _: 1
          }, 8, ["icon"]),
          (userrole.value != '经销商')
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 0,
                type: "primary",
                onClick: _cache[7] || (_cache[7] = ($event: any) => (add())),
                size: "small",
                icon: _unref(CirclePlus)
              }, {
                default: _withCtx(() => [
                  _hoisted_16
                ]),
                _: 1
              }, 8, ["icon"]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      onCellClick: lookLog,
      data: tableData.value,
      "header-cell-style": {color:'#000',backgroundColor:'#fafbfd'}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          type: "index",
          width: "60",
          label: "序号",
          align: "center"
        }),
        _createVNode(_component_el_table_column, {
          prop: "cell.code",
          label: "项目编号",
          width: "140"
        }),
        _createVNode(_component_el_table_column, {
          label: "项目名称",
          width: "220"
        }, {
          default: _withCtx((scope) => [
            _createElementVNode("div", _hoisted_17, _toDisplayString(scope.row.cell.projectname), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "cell.enddate",
          label: "要求交付时间",
          width: "110"
        }),
        _createVNode(_component_el_table_column, {
          prop: "cell.fzrname",
          label: "项目负责人",
          width: "100"
        }),
        _createVNode(_component_el_table_column, {
          label: "状态",
          width: "80"
        }, {
          default: _withCtx((scope) => [
            _createVNode(_component_el_tag, {
              type: _unref(getType)(scope.row.cell.status)
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(getStatus)(scope.row.cell.status)), 1)
              ]),
              _: 2
            }, 1032, ["type"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "项目操作",
          width: "350"
        }, {
          default: _withCtx((scope) => [
            (userrole.value != '经销商')
              ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 0,
                  link: "",
                  type: "primary",
                  size: "small",
                  onClick: _withModifiers(($event: any) => (lookLog(scope.row)), ["stop"])
                }, {
                  default: _withCtx(() => [
                    _hoisted_18
                  ]),
                  _: 2
                }, 1032, ["onClick"]))
              : _createCommentVNode("", true),
            (Number(scope.row.cell.type1) !== 4)
              ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 1,
                  link: "",
                  type: "primary",
                  size: "small",
                  onClick: _withModifiers(($event: any) => (ps(scope.row)), ["stop"])
                }, {
                  default: _withCtx(() => [
                    _hoisted_19
                  ]),
                  _: 2
                }, 1032, ["onClick"]))
              : _createCommentVNode("", true),
            _createVNode(_component_el_button, {
              link: "",
              type: "success",
              size: "small",
              onClick: _withModifiers(($event: any) => (openProjectInfo(scope.row)), ["stop"])
            }, {
              default: _withCtx(() => [
                _hoisted_20
              ]),
              _: 2
            }, 1032, ["onClick"]),
            _createVNode(_component_el_button, {
              link: "",
              type: "warning",
              size: "small",
              onClick: _withModifiers(($event: any) => (openAllFiles(scope.row)), ["stop"])
            }, {
              default: _withCtx(() => [
                _hoisted_21
              ]),
              _: 2
            }, 1032, ["onClick"]),
            (userrole.value != '经销商')
              ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 2,
                  link: "",
                  disabled: !canManage(scope.row),
                  type: "primary",
                  size: "small",
                  onClick: _withModifiers(($event: any) => (detailsProject(scope.row)), ["stop"])
                }, {
                  default: _withCtx(() => [
                    _hoisted_22
                  ]),
                  _: 2
                }, 1032, ["disabled", "onClick"]))
              : _createCommentVNode("", true),
            (scope.row.cell.status==4)
              ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 3,
                  disabled: !canManage(scope.row),
                  type: "warning",
                  size: "small",
                  onClick: _withModifiers(($event: any) => (hfProject(scope.row)), ["stop"])
                }, {
                  default: _withCtx(() => [
                    _hoisted_23
                  ]),
                  _: 2
                }, 1032, ["disabled", "onClick"]))
              : (_openBlock(), _createBlock(_component_el_button, {
                  key: 4,
                  link: "",
                  disabled: !canManage(scope.row),
                  type: "danger",
                  size: "small",
                  onClick: _withModifiers(($event: any) => (delProject(scope.row)), ["stop"])
                }, {
                  default: _withCtx(() => [
                    _hoisted_24
                  ]),
                  _: 2
                }, 1032, ["disabled", "onClick"]))
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, { label: "任务操作" }, {
          default: _withCtx((scope) => [
            _createVNode(_component_el_button, {
              link: "",
              type: "primary",
              size: "small",
              onClick: _withModifiers(($event: any) => (taskDetails(scope.row)), ["stop"])
            }, {
              default: _withCtx(() => [
                _hoisted_25
              ]),
              _: 2
            }, 1032, ["onClick"]),
            (userrole.value != '经销商')
              ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 0,
                  link: "",
                  type: "danger",
                  size: "small",
                  onClick: _withModifiers(($event: any) => (taskDetails1(scope.row)), ["stop"])
                }, {
                  default: _withCtx(() => [
                    _hoisted_26
                  ]),
                  _: 2
                }, 1032, ["onClick"]))
              : _createCommentVNode("", true),
            (userrole.value != '经销商')
              ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 1,
                  link: "",
                  type: "danger",
                  size: "small",
                  onClick: _withModifiers(($event: any) => (taskDetails2(scope.row)), ["stop"])
                }, {
                  default: _withCtx(() => [
                    _hoisted_27
                  ]),
                  _: 2
                }, 1032, ["onClick"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data"])), [
      [_directive_loading, loading.value]
    ]),
    _createElementVNode("div", _hoisted_28, [
      _createVNode(_component_el_pagination, {
        onSizeChange: handleSizeChange,
        onCurrentChange: handleCurrentChange,
        currentPage: pageIndex.value,
        "onUpdate:currentPage": _cache[8] || (_cache[8] = ($event: any) => ((pageIndex).value = $event)),
        "page-sizes": [10, 20, 30],
        "page-size": pageSize.value,
        "onUpdate:page-size": _cache[9] || (_cache[9] = ($event: any) => ((pageSize).value = $event)),
        layout: "total, sizes, prev, pager, next, jumper",
        total: pages.value.totalCount
      }, null, 8, ["currentPage", "page-size", "total"])
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: psShow.value,
      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((psShow).value = $event)),
      "show-close": false,
      "close-on-click-modal": false,
      top: "5vh",
      width: "92%"
    }, {
      header: _withCtx(({ close, titleId, titleClass }) => [
        _createElementVNode("div", _hoisted_29, [
          _hoisted_30,
          _createVNode(_component_el_icon, {
            class: "delicon",
            onClick: _cache[10] || (_cache[10] = ($event: any) => (psShow.value=false))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Close)
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _withDirectives((_openBlock(), _createElementBlock("div", null, [
          _createElementVNode("div", _hoisted_31, " 项目：" + _toDisplayString(psProject.value.code) + " - " + _toDisplayString(psProject.value.projectname) + "　｜　勾选\"创建\"后点击提交才会生成对应任务（默认全部创建） ", 1),
          _createElementVNode("div", _hoisted_32, [
            _createVNode(_component_el_button, {
              size: "small",
              onClick: _cache[11] || (_cache[11] = ($event: any) => (psSelectAll(true)))
            }, {
              default: _withCtx(() => [
                _hoisted_33
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, {
              size: "small",
              onClick: _cache[12] || (_cache[12] = ($event: any) => (psSelectAll(false)))
            }, {
              default: _withCtx(() => [
                _hoisted_34
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, {
              size: "small",
              onClick: psInvert
            }, {
              default: _withCtx(() => [
                _hoisted_35
              ]),
              _: 1
            }),
            _createElementVNode("span", _hoisted_36, "已选 " + _toDisplayString(_unref(psCheckedCount)) + " / " + _toDisplayString(psList.value.length), 1)
          ]),
          _createVNode(_component_el_table, {
            data: psList.value,
            border: "",
            size: "small",
            "header-cell-style": {fontSize:'12px',backgroundColor:'#fafbfd'}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                width: "90",
                align: "center",
                fixed: "left"
              }, {
                header: _withCtx(() => [
                  _createElementVNode("div", _hoisted_37, [
                    _createVNode(_component_el_checkbox, {
                      "model-value": _unref(psAllChecked),
                      indeterminate: _unref(psIndeterminate),
                      onChange: psSelectAll,
                      size: "small"
                    }, null, 8, ["model-value", "indeterminate"]),
                    _createElementVNode("span", {
                      style: {"font-size":"12px","cursor":"pointer","color":"#409EFF"},
                      onClick: psInvert
                    }, "反选")
                  ])
                ]),
                default: _withCtx(({row}) => [
                  _createVNode(_component_el_checkbox, {
                    modelValue: row.create,
                    "onUpdate:modelValue": ($event: any) => ((row.create) = $event),
                    "true-label": 1,
                    "false-label": 0
                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                label: "事项类型名称",
                width: "180",
                fixed: "left",
                "show-overflow-tooltip": ""
              }, {
                default: _withCtx(({row}) => [
                  _createElementVNode("span", null, _toDisplayString(row.type1), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                label: "上级任务",
                width: "220"
              }, {
                default: _withCtx(({row}) => [
                  _createVNode(_component_el_tree_select, {
                    modelValue: row.taskpid,
                    "onUpdate:modelValue": ($event: any) => ((row.taskpid) = $event),
                    data: psTaskTree.value,
                    props: {label:'tasktitle',children:'children'},
                    "node-key": "id",
                    "check-strictly": "",
                    "default-expand-all": "",
                    clearable: "",
                    placeholder: "（作为顶级任务）",
                    size: "small",
                    style: {"width":"100%"},
                    "render-after-expand": false
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "data"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                label: "开始时间",
                width: "150"
              }, {
                default: _withCtx(({row}) => [
                  _createVNode(_component_el_date_picker, {
                    modelValue: row.startdate,
                    "onUpdate:modelValue": ($event: any) => ((row.startdate) = $event),
                    type: "date",
                    placeholder: "开始时间",
                    "value-format": "YYYY-MM-DD",
                    size: "small",
                    style: {"width":"130px"}
                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                label: "结束时间",
                width: "150"
              }, {
                default: _withCtx(({row}) => [
                  _createVNode(_component_el_date_picker, {
                    modelValue: row.enddate,
                    "onUpdate:modelValue": ($event: any) => ((row.enddate) = $event),
                    type: "date",
                    placeholder: "结束时间",
                    "value-format": "YYYY-MM-DD",
                    size: "small",
                    style: {"width":"130px"}
                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                label: "执行人",
                width: "130"
              }, {
                default: _withCtx(({row}) => [
                  _createVNode(_component_el_select, {
                    filterable: "",
                    modelValue: row.zxr,
                    "onUpdate:modelValue": ($event: any) => ((row.zxr) = $event),
                    placeholder: "选择",
                    size: "small",
                    style: {"width":"110px"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_option, {
                        label: "",
                        value: ""
                      }),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(psUserList.value, (u, i) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          label: u.name,
                          value: `${u.id},${u.name}`,
                          key: i
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 2
                  }, 1032, ["modelValue", "onUpdate:modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                label: "审核人",
                width: "130"
              }, {
                default: _withCtx(({row}) => [
                  _createVNode(_component_el_select, {
                    filterable: "",
                    modelValue: row.shr,
                    "onUpdate:modelValue": ($event: any) => ((row.shr) = $event),
                    placeholder: "选择",
                    size: "small",
                    style: {"width":"110px"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_option, {
                        label: "",
                        value: ""
                      }),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(psUserList.value, (u, i) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          label: u.name,
                          value: `${u.id},${u.name}`,
                          key: i
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 2
                  }, 1032, ["modelValue", "onUpdate:modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                label: "任务状态",
                width: "120"
              }, {
                default: _withCtx(({row}) => [
                  _createVNode(_component_el_select, {
                    modelValue: row.status,
                    "onUpdate:modelValue": ($event: any) => ((row.status) = $event),
                    placeholder: "状态",
                    size: "small",
                    style: {"width":"100px"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_option, {
                        label: "未启动",
                        value: 0
                      }),
                      _createVNode(_component_el_option, {
                        label: "进行中",
                        value: 1
                      }),
                      _createVNode(_component_el_option, {
                        label: "关闭",
                        value: 2
                      }),
                      _createVNode(_component_el_option, {
                        label: "提交待审核",
                        value: 3
                      }),
                      _createVNode(_component_el_option, {
                        label: "完成",
                        value: 4
                      })
                    ]),
                    _: 2
                  }, 1032, ["modelValue", "onUpdate:modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                label: "同类型已创建",
                width: "110",
                align: "center"
              }, {
                default: _withCtx(({row}) => [
                  _createVNode(_component_el_tag, {
                    size: "small",
                    type: row.existType ? 'warning' : 'info'
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(row.existType ? '已创建' : '未创建'), 1)
                    ]),
                    _: 2
                  }, 1032, ["type"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                label: "任务描述",
                "min-width": "220"
              }, {
                default: _withCtx(({row}) => [
                  _createVNode(_component_el_input, {
                    modelValue: row.taskdescribe,
                    "onUpdate:modelValue": ($event: any) => ((row.taskdescribe) = $event),
                    placeholder: "任务描述",
                    size: "small",
                    type: "textarea",
                    rows: 1
                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                label: "附件",
                width: "220"
              }, {
                default: _withCtx(({row}) => [
                  _createVNode(_component_el_upload, {
                    action: `${api.value}/frame/uploadfile1`,
                    "file-list": row.fileList,
                    "on-success": (res,file,fl)=>onRowUploadSuccess(row,fl),
                    "on-remove": (file,fl)=>onRowUploadRemove(row,fl),
                    multiple: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_button, {
                        type: "primary",
                        size: "small",
                        plain: ""
                      }, {
                        default: _withCtx(() => [
                          _hoisted_38
                        ]),
                        _: 1
                      })
                    ]),
                    _: 2
                  }, 1032, ["action", "file-list", "on-success", "on-remove"]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((row.fileList||[]), (f, i) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: i,
                      style: {"margin-top":"2px"}
                    }, [
                      _createElementVNode("a", {
                        href: `${api.value}${f.response?f.response.data[0].url:f.url}`,
                        target: "_blank",
                        style: {"color":"#409EFF","font-size":"12px"}
                      }, _toDisplayString(f.name || ('附件' + String(Number(i) + 1))), 9, _hoisted_39)
                    ]))
                  }), 128))
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                label: "签字流程",
                width: "200"
              }, {
                default: _withCtx(({row}) => [
                  _createVNode(_component_el_select, {
                    modelValue: row.formid,
                    "onUpdate:modelValue": ($event: any) => ((row.formid) = $event),
                    placeholder: "选择签字流程",
                    size: "small",
                    clearable: "",
                    style: {"width":"100%"}
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formTemplateList.value, (item, index) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          label: item.formname,
                          value: Number(item.id),
                          key: index
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 2
                  }, 1032, ["modelValue", "onUpdate:modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                label: "是否加急",
                width: "110"
              }, {
                default: _withCtx(({row}) => [
                  _createVNode(_component_el_switch, {
                    modelValue: row.isurgent,
                    "onUpdate:modelValue": ($event: any) => ((row.isurgent) = $event),
                    "active-value": "是",
                    "inactive-value": "否"
                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["data"]),
          (psList.value.length===0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_40, "未配置\"订单信息-\"类事项类型，请先在【系统配置】中添加"))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_41, [
            _createVNode(_component_el_button, {
              onClick: _cache[13] || (_cache[13] = ($event: any) => (psShow.value=false)),
              round: ""
            }, {
              default: _withCtx(() => [
                _hoisted_42
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: submitPS,
              loading: psSubmitting.value,
              round: ""
            }, {
              default: _withCtx(() => [
                _hoisted_43
              ]),
              _: 1
            }, 8, ["loading"])
          ])
        ])), [
          [_directive_loading, psLoading.value]
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: addShowProject.value,
      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((addShowProject).value = $event)),
      "show-close": false,
      "close-on-click-modal": false
    }, {
      header: _withCtx(({ close, titleId, titleClass }) => [
        _createElementVNode("div", _hoisted_44, [
          _hoisted_45,
          _createVNode(_component_el_icon, {
            class: "delicon",
            onClick: _cache[15] || (_cache[15] = ($event: any) => (addShowProject.value=false))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Close)
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        (projectShow.value)
          ? (_openBlock(), _createBlock(AddProject, {
              key: 0,
              onCancel: cancel,
              uuid: uuid.value
            }, null, 8, ["uuid"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(ProjectAllFiles, {
      ref_key: "allFilesRef",
      ref: allFilesRef
    }, null, 512),
    _createVNode(_component_el_dialog, {
      modelValue: projectInfoShow.value,
      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((projectInfoShow).value = $event)),
      "show-close": false,
      "close-on-click-modal": false,
      width: "88%",
      top: "4vh"
    }, {
      header: _withCtx(({ close, titleId, titleClass }) => [
        _createElementVNode("div", _hoisted_46, [
          _createElementVNode("div", null, "完善项目信息 - " + _toDisplayString(projectInfoName.value), 1),
          _createVNode(_component_el_icon, {
            class: "delicon",
            onClick: _cache[17] || (_cache[17] = ($event: any) => (projectInfoShow.value=false))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Close)
            ]),
            _: 1
          })
        ])
      ]),
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[18] || (_cache[18] = ($event: any) => (projectInfoShow.value=false))
        }, {
          default: _withCtx(() => [
            _hoisted_47
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: saveProjectInfo,
          loading: projectInfoSaving.value
        }, {
          default: _withCtx(() => [
            _hoisted_48
          ]),
          _: 1
        }, 8, ["loading"])
      ]),
      default: _withCtx(() => [
        (projectInfoShow.value)
          ? (_openBlock(), _createBlock(ProjectInfoEdit, {
              key: 0,
              ref_key: "projectInfoRef",
              ref: projectInfoRef,
              projectuuid: projectInfoUuid.value,
              projectname: projectInfoName.value,
              projectcode: projectInfoCode.value,
              onSaved: onProjectInfoSaved
            }, null, 8, ["projectuuid", "projectname", "projectcode"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createElementVNode("div", _hoisted_49, [
      _createVNode(_component_el_dialog, {
        modelValue: logDetails.value,
        "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((logDetails).value = $event)),
        "show-close": false,
        fullscreen: ""
      }, {
        header: _withCtx(({ close, titleId, titleClass }) => [
          _createElementVNode("div", _hoisted_50, [
            _hoisted_51,
            _createVNode(_component_el_icon, {
              class: "delicon",
              onClick: _cache[20] || (_cache[20] = ($event: any) => (logDetails.value=false))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_Close)
              ]),
              _: 1
            })
          ])
        ]),
        default: _withCtx(() => [
          (logDetailsShow.value)
            ? (_openBlock(), _createBlock(AddProjectlog, {
                key: 0,
                projectnr: projectnr.value
              }, null, 8, ["projectnr"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["modelValue"])
    ])
  ]))
}
}

})